
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pizza/mexikansk",
      function () {
        return require("private-next-pages/pizza/mexikansk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pizza/mexikansk"])
      });
    }
  